/**
 * 请求接口
 */

import http from "./http"
import store from "../store"
import { getDevicedId, getUrlParam } from "@/utils/buryingPoint"
import { buryingPointUrl, specialPageArticleUrl } from "@/config"

export const getActivityDetail = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/index/activity?activityId=${params.activityId}`
  return http.post({ url, params: {}, finalFunc, showLoading })
}

export const getAreaStatistics = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/statistics/getAreaStatistics?activityId=${params.activityId}`
  return http.get({ url, finalFunc, showLoading })
}

export const getMyMessageList = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/message/messageCard?columnId=${params.columnId}`
  return http.post({ url, params: {}, finalFunc, showLoading })
}

export const handleInteractionprasie = ({ params = {}, finalFunc = null, showLoading = false } = {}) => {
  const url = `/like/click`
  return http.post({ url, params, finalFunc, showLoading })
}

export const getSpecialArticle = ({ params = {}, finalFunc = null, showLoading = false, showToast = false, interceptError = false } = {}) => {
  const url = `${specialPageArticleUrl}/special/showList?columnId=14&articleId=${params.articleId}&linkId=${params.linkId}&templateId=${params.templateId}&count=4`
  return http.get({ url, finalFunc, showLoading, showToast, interceptError })
}

export const buryingPoint = ({ params = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const baseParams = {
    deviceid: getDevicedId(),
    dataType: 1000099,
    actionTime: new Date()
      .getTime()
      .toString()
      .slice(0, 13),
    url: encodeURIComponent(window.location.href),
    refer: document.referrer || "",
    layer: getUrlParam("layer") || "",
    from: getUrlParam("from") || "",
    origin: 4,
    activityId: store.state.activityInfo.activityId || "",
    action: "",
    longitude: store.state.userInfo.userPosition.lng || "",
    latitude: store.state.userInfo.userPosition.lat || ""
  }
  Object.assign(baseParams, params)
  return http.get({ url: buryingPointUrl, params: baseParams, finalFunc, showLoading, showToast })
}

// /message/getTemplate 获取消息模板
export const getTemplate = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/message/getTemplate?columnId=${params.columnId}`
  return http.post({ url, params, finalFunc, showLoading })
}

// /message/sentMessage发布留言
export const sentMessage = ({ params = {}, finalFunc = null, showLoading = true } = {}) => {
  const url = `/message/sentMessage`
  params.userName = encodeURIComponent(params.userName)
  return http.post({ url, params, finalFunc, showLoading })
}
